"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PTTForm = void 0;

var _react = require("informel/react");

var _react2 = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _useLayoutEffectSSRSafe = require("../hooks/useLayoutEffectSSRSafe");

var _PTTLayout = require("./PTTLayout");

var _excluded = ["children", "formId", "disabled"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PTTForm = /*#__PURE__*/_react2["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$formId = _ref.formId,
      formId = _ref$formId === void 0 ? undefined : _ref$formId,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      rest = _objectWithoutProperties(_ref, _excluded);

  // We use forwardRef but we also need to use that ref internally: https://itnext.io/reusing-the-ref-from-forwardref-with-react-hooks-4ce9df693dd
  var fieldsetRef = _react2["default"].useRef(null);

  (0, _useLayoutEffectSSRSafe.useLayoutEffectSSRSafe)(function () {
    var _fieldsetRef$current;

    var handleInformUpdated = function handleInformUpdated(e) {
      if (e.target.matches('.blox.hidden-form-control')) {
        var bloxElement = e.target.parentElement.querySelector("[name=\"".concat(e.target.name, "\"]"));

        if (!bloxElement || bloxElement === e.target) {
          return;
        }

        switch (bloxElement.tagName.toLowerCase()) {
          case 'blox-select':
            if (bloxElement.hasAttribute('multiple')) {
              bloxElement.selectedValues = e.target.getSelectedOptions().map(function (o) {
                return o.value;
              });
            } else {
              bloxElement.selectedValue = e.target.value;
            }

            break;

          case 'blox-search':
            bloxElement.value = e.target.value;
            break;

          case 'blox-switch':
            bloxElement.checked = e.target.checked;
            break;

          default:
            console.error('Unhandled blox element in PTTForm: ' + bloxElement.tagName);
        }
      }
    };

    fieldsetRef === null || fieldsetRef === void 0 ? void 0 : (_fieldsetRef$current = fieldsetRef.current) === null || _fieldsetRef$current === void 0 ? void 0 : _fieldsetRef$current.addEventListener('inform-updated', handleInformUpdated);
    return function () {
      var _fieldsetRef$current2;

      fieldsetRef === null || fieldsetRef === void 0 ? void 0 : (_fieldsetRef$current2 = fieldsetRef.current) === null || _fieldsetRef$current2 === void 0 ? void 0 : _fieldsetRef$current2.removeEventListener('inform-updated', handleInformUpdated);
    };
  }, []);
  return /*#__PURE__*/_react2["default"].createElement(StyledInformEl, _extends({}, rest, {
    ref: ref
  }), /*#__PURE__*/_react2["default"].createElement("form", {
    id: formId
  }, /*#__PURE__*/_react2["default"].createElement(StyledFieldset, {
    disabled: disabled,
    ref: fieldsetRef
  }, children))); // Keeping the generics of Informel exposed: https://fettblog.eu/typescript-react-generic-forward-refs/#option-1%3A-type-assertion
});

exports.PTTForm = PTTForm;
PTTForm.displayName = 'PTTForm';
var StyledInformEl = (0, _styledComponents["default"])(_react.InformEl).withConfig({
  displayName: "PTTForm__StyledInformEl",
  componentId: "sc-nujx7e-0"
})(["--error-color:var(--blox-red);--error-margin:5px 0 0 0;--error-font-size:14px;--error-font-family:'sofia-pro';", ""], _PTTLayout.Layout);

var StyledFieldset = _styledComponents["default"].fieldset.withConfig({
  displayName: "PTTForm__StyledFieldset",
  componentId: "sc-nujx7e-1"
})(["border:none;padding:0;margin:0;"]);